export enum NoteType {
  推荐用户返利券=1,
  活动券=2,
  用户券=3,
  折扣券=5
}
export enum NoteTargeType{
  电子版型=1,
  纸质版型=2,
  服装面料= 3,
  辅料= 4,
  饰品=5,
  成衣定制=6,
  成衣售卖=7, 
  // 2026-08-12：客户端识别后台新增的教学课程券目标，保留既有核销对象编码不变。
  教学课程=8,
  升级会员=9
}
export enum NoteStatus{
  已发放=0,
  已领取=1,
  已使用=2,
  已停用=3
}
